import WithRender from "../../templates/base/summary.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getSummary"]),
    name: () => {
      return "Summary";
    }
  }
});
